/**
 * Lists the versions of a protocol collection
 */

import cx from 'classnames';
import { ProfilePicture } from 'labstep-web/components/Profile/Picture';
import { ProtocolLabelStatus } from 'labstep-web/components/Protocol/Label/Status';
import { Size } from 'labstep-web/core/Initials/types';
import LinkButton from 'labstep-web/core/Link/Button';
import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import type { Protocol } from 'labstep-web/models/protocol.model';
import { humanReadableDate } from 'labstep-web/services/date.service';
import type React from 'react';
import styles from './styles.module.scss';
import type {
  IProtocolCollectionVersionProps,
  IProtocolListProps,
} from './types';

export const ProtocolCollectionVersion: React.FC<
  IProtocolCollectionVersionProps
> = ({ protocol, active }) => (
  <div className={cx(styles.item, { [styles.active]: active })}>
    <ProfilePicture
      size={Size.mini}
      entity={protocol.author}
      linkable={false}
    />
    <LinkButton
      className={cx(styles.changes)}
      route={{
        to: 'protocol_show',
        params: {
          id: protocol.id,
        },
      }}
    >
      <div>
        <div className={styles.date}>
          {humanReadableDate(protocol.created_at)}
        </div>
        <div>
          <b>{protocol.printVersion}</b>
        </div>
        <div>{protocol.changes}</div>
      </div>
    </LinkButton>
    <ProtocolLabelStatus protocol={protocol} />
  </div>
);

export const ProtocolList: React.FC<IProtocolListProps> = ({
  activeProtocol,
  protocolCollectionId,
}) => (
  <ReadOnMountHOC
    type="cursor"
    loading={{ loader: false }}
    pagination={{ infinite: false }}
    entityName="protocol"
    params={{
      protocol_collection_id: protocolCollectionId,
      is_deleted: 'both',
    }}
    children={({ entities }) => (
      <div className={styles.list}>
        {entities.map((protocol: Protocol) => (
          <ProtocolCollectionVersion
            key={protocol.id}
            protocol={protocol}
            active={activeProtocol.id === protocol.id}
          />
        ))}
      </div>
    )}
  />
);
